import { ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { OrderSetFormComponent } from '../order-set-form/order-set-form.component';
import { OrderSet } from 'src/app/calvin-emr-shared/models/order-set.model';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'app-order-set-edit-dialog',
  imports: [
    ButtonDirective,
    OrderSetFormComponent
  ],
  standalone: true,
  templateUrl: './order-set-edit-dialog.component.html',
  styleUrl: './order-set-edit-dialog.component.scss'
})
export class OrderSetEditDialogComponent {
  @ViewChild('orderSetForm') orderSetForm!: OrderSetFormComponent;

  public ref = inject(DynamicDialogRef);
  public config = inject(DynamicDialogConfig);
  private cdRef = inject(ChangeDetectorRef);

  type: string;
  orderSet: OrderSet | undefined;

  constructor() {
    this.type = this.config.data.type;
    this.orderSet = this.config.data.orderSet;
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
  }

  closeDialog(): void {
    this.ref.close();
  }

  /**
   *  Submit the order set form and send the order set data to the patient component
   */
  onSubmit() {
    this.orderSet = this.orderSetForm.createOrderSetFromForm();
    this.ref.close(this.orderSet);
  }

  get btnLabel() {
    return this.type === 'create' ? 'Create' : 'Update';
  }

  get isFormValid() {
    if (this.orderSetForm !== undefined && this.orderSetForm !== null) {
      return this.orderSetForm.form.valid;
    }
    return false;
  }
}


